
import { useState } from 'react';
import Form from 'react-bootstrap/Form';

function LabReportsHistory() {

    return (
        <>
            <main style={{ width: "100%", height: "100%" }}>
                <div className="row">
                    <div style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }} className="col-12 mb-4 d-flex justify-content-between">

                        <div className="d-flex">
                            <h4 className='m-0 p-3'>
                                Test and Lab Reports History
                            </h4>
                        </div>

                        <div className='d-flex align-items-center justify-content-end gap-3'>
                            <div className='d-flex align-items-center gap-3'>
                                <div className="position-relative div-okij8ijj">
                                    <input type="text" className="form-control div-TzEiOdMeYO" placeholder='Search here' style={{ padding: "0px 1.7rem 0px .5rem", borderRadius: ".3rem" }} />
                                    <div className="position-absolute" style={{ top: "10px", right: '8px' }}>
                                        <button style={{ background: "none", border: 'none', }}><i class="fa-solid fa-magnifying-glass"></i></button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 mb-3">
                        <div className="d-flex align-items-center justify-content-end gap-2">
                            <div className="d-flex align-items-center gap-2">
                                <span className='fw-semibold'>Report Type</span>
                                <Form.Select aria-label="Default select example" >
                                    <option>Report Type</option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </Form.Select>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <span className='fw-semibold'>Sort by:</span>
                                <input style={{ width: '8rem' }} type="date" className='form-control' />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div style={{ height: "42rem" }} className="col-12 row">
                        <div className="col-5 p-3" style={{ overflowY: "scroll", border: "1px solid #D6DADD", borderRadius: "6px", height: "100%" }}>
                            <div style={{ backgroundColor: "#C6FFD7", borderRadius: "5px" }} className=" mb-2 d-flex p-2 align-items-start justify-content-between gap-2">
                                <div className="d-flex align-items-center gap-2">
                                    <span style={{ width: "2rem", height: '2rem', background: "#F46B68", borderRadius: "3rem" }}></span>
                                    <div className='d-flex flex-column gap-2'>
                                        <span className='fw-semibold' style={{ fontSize: "14px" }}>Blood test results</span>
                                        <span style={{ fontSize: "12px" }}>Sat, 23 Jul 2020, 01:24 PM</span>
                                    </div>
                                </div>

                                <div className='d-flex gap-2'>
                                    <span style={{ fontSize: "14px" }}>Assigned to</span>
                                    <span style={{ color: "#2662F0", fontSize: "14px" }}>Nichols Labs</span>
                                </div>
                            </div>

                            <div style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="mb-2 d-flex p-2 align-items-start justify-content-between gap-2">
                                <div className="d-flex align-items-center gap-2">
                                    <span style={{ width: "2rem", height: '2rem', background: "#2662F0", borderRadius: "3rem" }}></span>
                                    <div className='d-flex flex-column gap-2'>
                                        <span className='fw-semibold' style={{ fontSize: "14px" }}>X-Ray</span>
                                        <span style={{ fontSize: "12px" }}>Sat, 23 Jul 2020, 01:24 PM</span>
                                    </div>
                                </div>

                                <div className='d-flex gap-2'>
                                    <span style={{ fontSize: "14px" }}>Assigned to</span>
                                    <span style={{ color: "#2662F0", fontSize: "14px" }}>Nichols Labs</span>
                                </div>
                            </div>

                            <div style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="mb-2 d-flex p-2 align-items-start justify-content-between gap-2">
                                <div className="d-flex align-items-center gap-2">
                                    <span style={{ width: "2rem", height: '2rem', background: "#F46B68", borderRadius: "3rem" }}></span>
                                    <div className='d-flex flex-column gap-2'>
                                        <span className='fw-semibold' style={{ fontSize: "14px" }}>Blood test results</span>
                                        <span style={{ fontSize: "12px" }}>Sat, 23 Jul 2020, 01:24 PM</span>
                                    </div>
                                </div>

                                <div className='d-flex gap-2'>
                                    <span style={{ fontSize: "14px" }}>Assigned to</span>
                                    <span style={{ color: "#2662F0", fontSize: "14px" }}>Nichols Labs</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-7 ps-4 pe-0">
                            <div className="row border bg-white rounded-2" style={{ overflowY: 'scroll' }}>
                                <div className="col-12 mt-2">
                                    <div className="d-flex align-items-center justify-content-between  mb-3" style={{ borderBottom: 'dashed 1px #A2C0D4', paddingBottom: "1rem" }}>
                                        <span>Lab Reports</span>
                                        <button className='border-0 rounded-5 d-flex gap-2' style={{ background: "#F46B68", color: "#fff", padding: '.2rem 1rem' }}>
                                            <span><i class="material-icons d-flex align-items-center" style={{ fontSize: "1.2rem" }}>picture_as_pdf</i></span>
                                            <span>Prescription.pdf</span>
                                            <span><i class="fa-solid fa-download"></i></span>
                                        </button>
                                    </div>

                                    <div className="d-flex flex-column gap-2 mb-3" style={{ borderBottom: 'solid 1px #A2C0D4', paddingBottom: "1rem" }}>
                                        <div className="d-flex align-items-center gap-3">
                                            <span className='fw-bold' style={{ fontSize: "16px" }}>Jordan .M</span>
                                            <span className='fw-semibold' style={{ fontSize: "12px" }}>Age : 68</span>
                                            <span className='fw-semibold' style={{ fontSize: "12px" }}>Blood Group : O+</span>
                                            <span className='fw-semibold' style={{ fontSize: "12px" }}>BP : 120/80</span>
                                            <span className='fw-semibold' style={{ fontSize: "12px" }}>Pulse : 40 – 60 bpm</span>
                                            <span className='fw-semibold' style={{ fontSize: "12px", color: "#8D8D8D" }}>#123456abc</span>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="d-flex align-items-center gap-2">
                                                    <span className='fw-semibold' style={{ fontSize: "12px" }}>Assigned to</span>
                                                    <span className='fw-semibold' style={{ fontSize: "12px", color: "#2662F0" }}>DR. AbhiRam</span>
                                                </div>

                                                <div className="d-flex align-items-center gap-2">
                                                    <span className='fw-semibold' style={{ fontSize: "12px" }}>Department</span>
                                                    <span className='fw-semibold' style={{ fontSize: "12px", color: "#2662F0" }}>General Physician</span>
                                                </div>
                                            </div>

                                            <span className='fw-semibold' style={{ fontSize: "12px", color: "#8D8D8D" }}>Sat, 23 Jul 2020, 01:24 PM</span>

                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 mb-3">
                                    <img style={{ width: "40rem" }} src="/Images/Lab-History.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




            </main>

        </>
    )
}

export default LabReportsHistory